import { db } from "../../../service/API";

import store from "../../store/store";

// Tools
const ft = require("../Tools/FileTools");

export class ProfileSocietyConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  getSoc() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileSocietyConnector/socData/")
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get soc failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get soc " + err.message);
        });
    });
  }

  getPlayerForAll() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileSocietyConnector/playerForAll/")
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get player for all failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get player for all " + err.message);
        });
    });
  }

  getDateExpire() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileSocietyConnector/dtExpire/")
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get date expire failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get date expire " + err.message);
        });
    });
  }

  getPlayerForSoc(sid) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileSocietyConnector/playerForSoc/" + sid)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get player for society failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get player for society " + err.message);
        });
    });
  }

  insertSoc(socData) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileSocietyConnector/insertSoc/", { socData: socData })
        .then((response) => {
          if (response.status == 201) {
            // TODO: make db send directly insert id
            let workingDirectory = 999;

            if (response.data.insertId !== undefined) {
              workingDirectory = response.data.insertId;
            }

            ft.createDir(store.state.config.dirs.root + "mediacenter/" + workingDirectory.toString())
              .then(() => {
                if (response.status == 201) {
                  return resolve();
                } else {
                  return reject("create dir failed with status " + response.status);
                }
              })
              .catch((err) => {
                return reject(err.message);
              });
          } else {
            return reject("insert society failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert society " + err.message);
        });
    });
  }

  insertUser(userData) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileSocietyConnector/insertUser/", { userData: userData })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert user failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert user " + err.message);
        });
    });
  }

  insertPlayer(playerData) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileSocietyConnector/insertPlayer/", {
        playerData: playerData,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert player failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert player " + err.message);
        });
    });
  }

  updateSoc(socData) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileSocietyConnector/updateSoc/", { socData: socData })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update society failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update society " + err.message);
        });
    });
  }

  updateUser(userData) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileSocietyConnector/updateUser/", { userData: userData })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update user failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update user " + err.message);
        });
    });
  }

  updatePlayer(playerData) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileSocietyConnector/updatePlayer/", {
        playerData: playerData,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update player failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update player " + err.message);
        });
    });
  }

  //Récupération des sociétés associés au player sélectionné (Super admin uniquement)
  getAssociatedSoc(pid) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileSocietyConnector/associatedSoc/", { pid: pid })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get associated societies failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get associated societies " + err.message);
        });
    });
  }

  updateAssociatedSoc(pid, associatedSocieties) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileSocietyConnector/updateAssociatedSoc/", {
        pid: pid,
        associatedSocieties: associatedSocieties,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update associated societies failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update associated societies " + err.message);
        });
    });
  }

  delPlayer(pid) {
    return new Promise((resolve, reject) => {
      db.delete("/ProfileSocietyConnector/delPlayer/", { pid: pid })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("delete player failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on delete player " + err.message);
        });
    });
  }

  updateLicense(players, soc, dt_expire) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileSocietyConnector/updateLicense/", {
        players: players,
        soc: soc,
        dt_expire: dt_expire,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update license failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update license " + err.message);
        });
    });
  }

  listDataLicense(date) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileSocietyConnector/listDataLicense/", { date: date })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("list data license failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on list data license " + err.message);
        });
    });
  }

  checkDuplicate(key, name, id) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileSocietyConnector/checkDuplicate/", {
        key: key,
        name: name,
        id: id,
      })
        .then((response) => {
          if (response.status == 200) {
            const result = response.data.length == 0;
            return resolve(result);
          } else {
            return reject("check duplicate failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on check duplicate " + err.message);
        });
    });
  }
}
